import { httpGet, httpPatch } from "../connection.js";

const getTenantSettings = async () => {
  return await httpGet(`/tenant-settings`);
};

const updateTenantSettings = async (values: {
  id: number;
  enabled: boolean;
}) => {
  return await httpPatch(`/tenant-settings/${values.id}`, {
    enabled: values.enabled,
  });
};

const TenantSettingsAPI = {
  getTenantSettings,
  updateTenantSettings,
};

export default TenantSettingsAPI;
